export default "__VITE_PUBLIC_ASSET__b7358c80__"